import { Component, Input } from '@angular/core';
import { Month } from '../accommodations.model';
import { AccommodationsService } from '../accommodations.service';

@Component({
	selector: 'app-accommodations-datebar',
	templateUrl: './accommodations-datebar.component.html',
	styleUrls: ['./accommodations-datebar.component.scss'],
})
export class AccommodationsDatebarComponent {
	@Input() months: Month[] = [];
	selectedColumns: Array<any> = [];

	constructor(protected service: AccommodationsService) {}

	protected counter(end: number, start = 1): number[] {
		const list = [];
		for (let i = start; i <= end; i++) {
			list.push(i);
		}
		return list;
	}
	dayClicked(month, day: number): void {
		const divName = month.name + '-' + day;
		const index = this.selectedColumns.findIndex((obj) => obj == divName);
		if (index == -1) {
			this.selectedColumns.push(divName);
			return;
		}
		this.selectedColumns.splice(index, 1);
	}
}
